var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"select_lang"},[_c('a',{class:[{'active':_vm.lang === 'cn'}],on:{"click":function($event){return _vm.changelang('cn')}}},[_vm._v("中文")]),_vm._v(" "),_c('span'),_vm._v(" "),_c('a',{class:[{'active':_vm.lang === 'en'}],on:{"click":function($event){return _vm.changelang('en')}}},[_vm._v("EN")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8dc0a79a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/language.vue
// module id = null
// module chunks = 